<template>
    <div
        class="relative pt-6 pb-12 text-center sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32"
    >
        <keep-alive>
            <Header />
        </keep-alive>
        <div class="flex flex-col items-center justify-center ">
            <h1 class="pt-4 mt-4 text-3xl font-bold text-blue-600 ">
                Configurer un Business Plan
            </h1>
            <div
                class="w-1/4 h-3 mb-6 -mt-2 border-b-4 border-blue-600 rounded "
            ></div>
            <h2 class="pt-4 mt-2 mb-6 text-xl text-blue-600 ">
                Bonjour {{ userName }}, commencez la création de votre business
                plan en ligne.
            </h2>
        </div>
        <div class="flex justify-center gap-5 ">
            <version-card title="Version Simplifiée">
                <template v-slot:first-Paragraph
                    >Il est préférable d’utiliser cette version si votre
                    programme d’investissement est inférieur à 500.000Dhs
                </template>
            </version-card>
            <version-card title="Version Détaillée">
                <template v-slot:first-Paragraph
                    >Il est préférable d’utiliser cette version si votre
                    programme d’investissement est supérieure à
                    500.000Dhs</template
                >
            </version-card>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import VersionCard from "@/components/cards/versionCard";
import { auth } from "@/services/firebase.service.js";
import { titleCase } from "@/utils.js";

export default {
    components: { Header, VersionCard },
    data() {
        return {
            userName: ""
        };
    },
    created() {
        this.userName = titleCase(auth.currentUser.displayName);
    }
};
</script>
